import script from "./10.ExperienceSkinBreakouts.vue?vue&type=script&setup=true&lang=ts"
export * from "./10.ExperienceSkinBreakouts.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__